import React from 'react';
import { Button } from '../../../../../base/components/Button';
import { Modal } from '../../../../../base/components/Modal';
import { __t } from '../../../../../base/utils/t';
import { ReactComponent as Icon } from '../../assets/img/vacancy-limit-modal-icon.svg';

import './styles.scss';

interface Props {
    visible: boolean;
    visibilityHandler: () => void;
}

export const VacancyLimitModal = ({ visible, visibilityHandler }: Props) => {
    const goToPackages = () => {
        window.location.href = '/subscription/packages';
    };

    return (
        <Modal visible={visible} visibilityHandler={visibilityHandler} className='vacancy-limit-modal'>
            <Icon className='vacancy-limit-modal__icon' />
            <p className='vacancy-limit-modal__title'>{__t('Ліміт активних вакансій досягнуто')}</p>
            <p className='vacancy-limit-modal__text'>
                {__t(
                    'У вашому тарифі вже використано максимальну кількість одночасно активних вакансій. Щоб опублікувати нову, закрийте одну з існуючих або оберіть інший тариф.',
                )}
            </p>
            <div className='vacancy-limit-modal__buttons'>
                <Button type='primary' onClick={goToPackages} className='vacancy-limit-modal__button'>
                    {__t('Переглянути тарифи')}
                </Button>
                <Button type='link' onClick={visibilityHandler} className='vacancy-limit-modal__button'>
                    {__t('Не зараз')}
                </Button>
            </div>
        </Modal>
    );
};
